module.exports = __webpack_public_path__ + "img/PBatteringRam64_ua.6add78b2.webp";